export const GET_CONTENT_DISCOVERY = 'GET_CONTENT_DISCOVERY'
export const GET_CONTENT_DISCOVERY_FULFILLED = 'GET_CONTENT_DISCOVERY_FULFILLED'
export const GET_CONTENT_DISCOVERY_REJECTED = 'GET_CONTENT_DISCOVERY_REJECTED'

/**
 * @typedef Params
 * @property {number} [perPage] - number of results per page
 * @property {number} [offset] - starting offset
 * @property {string} [sortColumn] - column to sort on
 * @property {string} [sortDirection] - asc or desc
 * @property {object} [filters] - (facebook, twitter, instagram, embed, email, asset)
 *
 * @param {{
 *  resourceType: string,
 *  resourceId: string,
 *  params: Params,
 * }} payload
 * @link http://api.promoboxx.com/docs/V2/content_discovery.html
 */
export const getContentDiscovery = (payload) => ({
  type: GET_CONTENT_DISCOVERY,
  payload,
})
